import type { DPDay } from '@rehookify/datepicker';
import { useDaysPropGetters } from '@rehookify/datepicker';
import clsx from 'clsx';
import { use } from 'react';
import { DatePickerContext } from './DatePickerContext.ts';
import { normalizeDatePickerDate, normalizeDateTime } from './utils.ts';

export function DatePickerDay({ day }: { day: DPDay }) {
  const { dpState, include, renderDay, timezone } = use(DatePickerContext);
  const { dayButton } = useDaysPropGetters(dpState);

  const { $date, inCurrentMonth, range, selected } = day;

  if (!inCurrentMonth) {
    return <div className="aspect-square w-full" />;
  }

  const date = normalizeDatePickerDate($date, timezone);

  let disabled = day.disabled;
  if (include) {
    disabled = !include.find(d => normalizeDateTime(d, timezone).equals(date));
  }

  return (
    <div className="aspect-square">
      <div
        className={clsx(
          'size-full p-px',
          !!range && 'bg-primary-50',
          (range === 'range-start' ||
            range === 'range-start range-end' ||
            range === 'will-be-range-start') &&
            'rounded-l-full',
          (range === 'range-end' ||
            range === 'range-start range-end' ||
            range === 'will-be-range-end') &&
            'rounded-r-full'
        )}
      >
        <button
          {...dayButton(day, { disabled })}
          className={clsx(
            'block h-full w-full rounded-full border-2 border-transparent',

            !disabled &&
              (selected || range === 'range-start' || range === 'range-end') &&
              'bg-primary-600 text-white',
            !disabled && !selected && 'hover:border-primary-600',
            disabled ? 'pointer-events-none text-gray-300 line-through' : 'font-medium'
          )}
          disabled={disabled}
          type="button"
        >
          {renderDay ? renderDay({ date, isSelected: selected }) : <>{date.day}</>}
        </button>
      </div>
    </div>
  );
}
